<template>
  <div class="row">
    <div class="col-12 col-lg-6 mb-3">
      <coozzy-card class="h-100 info-card">
        <h5 class="info-card-title mb-3">
          <coozzy-address-card-icon class="mr-2" />
          {{ $t('message.digitalReference.applicant') }}
        </h5>
        <div
          v-for="field in applicantFields"
          :key="field.label"
          class="info-row">
          <span class="info-label">{{ field.label }}</span>
          <span class="info-value">{{ field.value || '–' }}</span>
        </div>
      </coozzy-card>
    </div>
    <div class="col-12 col-lg-6 mb-3">
      <coozzy-card class="h-100 info-card">
        <h5 class="info-card-title mb-3">
          <coozzy-building-icon class="mr-2" />
          {{ $t('message.digitalReference.administration') }}
        </h5>
        <div
          v-for="field in administrationFields"
          :key="field.label"
          class="info-row">
          <span class="info-label">{{ field.label }}</span>
          <span class="info-value">{{ field.value || '–' }}</span>
        </div>
      </coozzy-card>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzyAddressCardIcon from '@/framework/components/icons/CoozzyAddressCardIcon.vue'
import CoozzyBuildingIcon from '@/framework/components/icons/CoozzyBuildingIcon.vue'
import { V2ReferenceFormAdministration, V2ReferenceFormApplicant } from '@/types/api'
import { formatAddress, formatPersonName, formatTypeDate } from '@/misc/utils/digitalReferenceFormatters'

interface InfoField {
  label: string
  value: string
}

export default Vue.extend({
  name: 'DigitalReferenceInfoCards',
  components: {
    CoozzyCard,
    CoozzyAddressCardIcon,
    CoozzyBuildingIcon
  },
  props: {
    applicant: {
      type: Object as PropType<V2ReferenceFormApplicant>,
      default: null
    },
    administration: {
      type: Object as PropType<V2ReferenceFormAdministration>,
      default: null
    }
  },
  computed: {
    applicantFields(): InfoField[] {
      return [
        { label: this.$t('message.digitalReference.fields.name') as string, value: formatPersonName(this.applicant?.name) },
        { label: this.$t('message.digitalReference.fields.dateOfBirth') as string, value: formatTypeDate(this.applicant?.dateOfBirth) },
        { label: this.$t('message.digitalReference.fields.address') as string, value: formatAddress(this.applicant?.address) },
        { label: this.$t('message.digitalReference.fields.mobile') as string, value: this.applicant?.mobile || '' }
      ]
    },
    administrationFields(): InfoField[] {
      return [
        { label: this.$t('message.digitalReference.fields.name') as string, value: this.administration?.companyName || '' },
        { label: this.$t('message.digitalReference.fields.assignee') as string, value: formatPersonName(this.administration?.assigneeName) },
        { label: this.$t('message.digitalReference.fields.address') as string, value: formatAddress(this.administration?.address) },
        { label: this.$t('message.digitalReference.fields.telephone') as string, value: this.administration?.telephone || '' }
      ]
    }
  }
})
</script>

<style lang="scss" scoped>
.info-card-title {
  display: flex;
  align-items: center;
}

.info-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 0;
  border-bottom: 1px solid $color-bg-grey-dark;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  color: $color-text-grey-dark;
  flex-shrink: 0;
}

.info-value {
  text-align: right;
  font-weight: 500;
}
</style>
